/* NEW: UI_REVAMP */
export const HISTORY_SITE_OPTIONS = ['All', 'PCSO', 'STL'];

export const HISTORY_STATUS_OPTIONS = [
	{ label: 'All', value: 'All' },
	{ label: 'Posted', value: 'Posted' },
	{ label: 'Voidable', value: 'Voidable' },
	{ label: 'Voided', value: 'Voided' },
	{ label: 'Denied', value: 'Denied' },
	{ label: 'Strike', value: 'Striked' },
];

export const getDefaultTransactionDateRange = ({ selected, startDate, endDate }) => {
	const fallbackDate = selected || new Date();
	const rangeStart = startDate || fallbackDate;
	const rangeEnd = endDate || rangeStart;

	return [rangeStart, rangeEnd];
};
